import api from './client';

// Helper to get user_id from localStorage
const getUserId = () => {
  const user = localStorage.getItem('user');
  if (user) {
    try {
      const parsed = JSON.parse(user);
      return parsed._id || parsed.id;
    } catch (e) {
      return null;
    }
  }
  return null;
};

// Messages API
export const messagesAPI = {
  // Student endpoints
  getStudentInbox: async (page = 1, limit = 20) => {
    const userId = getUserId();
    const response = await api.get(`/messages/student/inbox`, { params: { user_id: userId, page, limit } });
    return response.data;
  },

  getStudentSent: async (page = 1, limit = 20) => {
    const userId = getUserId();
    const response = await api.get(`/messages/student/sent`, { params: { user_id: userId, page, limit } });
    return response.data;
  },

  studentSendMessage: async (recipientId, subject, content, applicationId = null) => {
    const userId = getUserId();
    const response = await api.post(`/messages/student/send`, {
      recipient_id: recipientId,
      recipient_type: 'university',
      subject,
      content,
      application_id: applicationId,
    }, { params: { user_id: userId } });
    return response.data;
  },

  getStudentMessage: async (messageId) => {
    const userId = getUserId();
    const response = await api.get(`/messages/student/${messageId}`, { params: { user_id: userId } });
    return response.data;
  },

  studentReplyMessage: async (messageId, content) => {
    const userId = getUserId();
    const response = await api.post(`/messages/student/${messageId}/reply`, { content }, { params: { user_id: userId } });
    return response.data;
  },

  // University endpoints
  getUniversityInbox: async (universityId, page = 1, limit = 20) => {
    const response = await api.get(`/messages/university/inbox`, { params: { university_id: universityId, page, limit } });
    return response.data;
  },

  getUniversitySent: async (universityId, page = 1, limit = 20) => {
    const response = await api.get(`/messages/university/sent`, { params: { university_id: universityId, page, limit } });
    return response.data;
  },

  universitySendMessage: async (universityId, recipientId, subject, content, applicationId = null) => {
    const response = await api.post(`/messages/university/send`, {
      recipient_id: recipientId,
      recipient_type: 'student',
      subject,
      content,
      application_id: applicationId,
    }, { params: { university_id: universityId } });
    return response.data;
  },

  getUniversityMessage: async (messageId, universityId) => {
    const response = await api.get(`/messages/university/${messageId}`, { params: { university_id: universityId } });
    return response.data;
  },

  universityReplyMessage: async (messageId, content, universityId) => {
    const response = await api.post(`/messages/university/${messageId}/reply`, { content }, { params: { university_id: universityId } });
    return response.data;
  },

  // Common endpoints
  updateMessage: async (messageId, updates, userId = null, universityId = null) => {
    const params = {};
    if (userId) params.user_id = userId;
    if (universityId) params.university_id = universityId;
    const response = await api.put(`/messages/${messageId}`, updates, { params });
    return response.data;
  },

  deleteMessage: async (messageId, userId = null, universityId = null) => {
    const params = {};
    if (userId) params.user_id = userId;
    if (universityId) params.university_id = universityId;
    const response = await api.delete(`/messages/${messageId}`, { params });
    return response.data;
  },

  // Application-based messaging (Student to University on application)
  getApplicationMessages: async (applicationId) => {
    const userId = getUserId();
    const response = await api.get(`/messages/application/${applicationId}/messages`, { params: { user_id: userId } });
    return response.data;
  },

  studentReplyToApplication: async (applicationId, message, subject = null) => {
    const userId = getUserId();
    const response = await api.post(`/messages/application/${applicationId}/reply`, {
      message,
      subject
    }, { params: { user_id: userId } });
    return response.data;
  },

  markApplicationMessageRead: async (applicationId, messageId) => {
    const userId = getUserId();
    const response = await api.put(`/messages/application/${applicationId}/messages/${messageId}/read`, {}, { params: { user_id: userId } });
    return response.data;
  },
};

export default messagesAPI;
